import { HTML_WIDTH, DESKTOP_BREAKPOINT, TABLET_BREAKPOINT, TRIGGER_OVERLAY_ON_RELOAD_PAGE_ON_DESKTOP_BREAKPPOINT } from './default-variables';

let screen_is_used = HTML_WIDTH < DESKTOP_BREAKPOINT ? 'mobile' : 'desktop';


// laddar om sidan om breakpoint är passerad mobil <--> desktop
export function breakpoint_reload_page() {
  let screen_size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  //$('#PreLoad').addClass('resize');
  //$('#PreLoad').show();
  //$('#Header').hide();
		if(screen_is_used == 'mobile' && DESKTOP_BREAKPOINT <= screen_size) {
      if(TRIGGER_OVERLAY_ON_RELOAD_PAGE_ON_DESKTOP_BREAKPPOINT) {
        $('#PreLoad').css('display', 'block');
      }
			location.reload();
		} else if (screen_is_used == 'desktop' &&  screen_size < DESKTOP_BREAKPOINT) {
      if(TRIGGER_OVERLAY_ON_RELOAD_PAGE_ON_DESKTOP_BREAKPPOINT) {
        $('#PreLoad').css('display', 'block');
      }
			location.reload();
		}
}

// justerar width för dropdown-menyn från comboboxar -> ger samma width som förälder har
export function comboBox_width() {
  if($('.form-group .comboBox').length) {
    $('.form-group .comboBox').each(function() {
        let width = $('input', this).outerWidth();
        $('.comboBoxDataContainer', this).css({ "width": width, "max-width": width })
      })
  }
}
